import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import handle401 from '../handle-401';
import HttpClient from '../../Api/HttpClient';

export function getCrmStages({ crm, pipeline }) {
  return queryOptions({
    queryKey: ['crm-stages', crm, pipeline],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.fetchCrmStatus({
        crm_name: crm,
        pipeline_id: pipeline,
      });

      return data.stages;
    }),
  });
}

export function getCrmPipelines({ crm }) {
  return queryOptions({
    queryKey: ['crm-pipelines', crm],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.fetchCrmStatus({
        crm_name: crm,
      });

      return data.pipelines?.pipelines || [];
    }),
  });
}

export function getCrmDeals({ crm, stage, searchText, page = 0, pipeline }) {
  let queryKey = ['crm-deals', crm, stage];

  if (crm !== 'salesforce') {
    queryKey = ['crm-deals', crm, stage, searchText, page, pipeline];
  }

  return queryOptions({
    placeholderData: keepPreviousData,
    queryKey,
    queryFn: handle401(async () => {
      if (!stage && !searchText) {
        return { next: 0, more: false, deals: [] };
      }

      const { data } = await HttpClient.getCrmDealList({
        crm,
        pipeline,
        stage,
        searchText,
        page,
      });

      return {
        next: data.next,
        hasMore: data.more,
        deals: data.deals.map((deal) => ({
          id: deal.id,
          name: deal.dealname,
          amount: parseInt(deal.amount || '0', 10),
          closeDate: deal.closedate,
          alreadyImported: deal.already_imported,
          stageId: deal.crm_stage,
        })),
      };
    }),
  });
}

export function loadCrmDeal({ crmSystem, dealId, enabled = true }) {
  return queryOptions({
    queryKey: ['crm-deal', crmSystem, dealId],
    queryFn: handle401(async () => {
      if (!dealId) {
        return null;
      }

      const { data } = await HttpClient.getCrmDeal({ crm: crmSystem, deal: dealId });

      return data.deal[0];
    }),
    enabled,
  });
}
